export * from '@primeuix/themes/material/megamenu';
export { default } from '@primeuix/themes/material/megamenu';
